module.exports = __webpack_public_path__ + "img/side-icon-41-off.1711d2ca.svg";